export var AuthenticationStrategy;
(function (AuthenticationStrategy) {
    AuthenticationStrategy["CONSUMER_OTP"] = "CONSUMER_OTP";
    AuthenticationStrategy["LVLR"] = "LVLR";
    AuthenticationStrategy["MDES"] = "MDES";
    AuthenticationStrategy["THREE_DS"] = "3DS";
    AuthenticationStrategy["FIDO2"] = "FIDO2";
    AuthenticationStrategy["CSC_VALIDATION"] = "CSC_VALIDATION";
})(AuthenticationStrategy || (AuthenticationStrategy = {}));
